import { Row, Col, Breadcrumb } from "react-bootstrap";
import { IInstructionDetails } from "../../../api/Instruction";
import { ILicenceProfile } from "../../../api/ILicenceProfile";
import { GetLicenseeReturnPageUrl } from "../../routeFactory";

interface BreadcrumbProps {
  licenceProfile: ILicenceProfile;
  instruction: IInstructionDetails;
}

const BreadCrumbs = ({ licenceProfile, instruction }: BreadcrumbProps) => (
  <Row>
    <Col xs="12">
      <Breadcrumb className="leap">
        <Breadcrumb.Item href="/">LEAP Online Home</Breadcrumb.Item>
        <Breadcrumb.Item href={`/licence-profile/${instruction.profileNo}`}>
          {licenceProfile.organisation} - {instruction.profileNo}
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${instruction.profileNo}/compliance`}
        >
          Compliance
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={GetLicenseeReturnPageUrl(
            instruction.profileNo,
            instruction.licenseesubmissionid
          )}
        >
          {instruction.licenseeReturn?.reference}
        </Breadcrumb.Item>
        <Breadcrumb.Item active>{instruction.reference}</Breadcrumb.Item>
      </Breadcrumb>
    </Col>
  </Row>
);

export default BreadCrumbs;
